/**
 * Класс для управления сообщениями.
 * @class
 */
export class MessageManager {
  constructor(elem) {
    return this._init(elem);
  }
  /**
   * Инициализация менеджера сообщений.
   * @private
   * @param {HTMLDivElement} elem
   * @returns {MessageManager} Экземпляр менеджера сообщений.
   */
  _init(elem = null) {
    const lastContainer = this._container;
    this._container = elem;
    if (this._container.messageManager instanceof MessageManager && lastContainer == elem) return this._container.messageManager;
    this._container.messageManager = this;
    window.MessageManager = this;
    return this;
  }
  /**
   * Обрабатывает ответ с сервера (или из другого источника).
   * @param {any} data - Входные данные (ответ).
   */
  processResponse(data) {
    const answer = data.answer ? data.answer : data;
    if (answer.messages) {
      answer.messages.forEach((messegeData) => {
        this.showMessage(messegeData);
      });
    }
  }

  closer(wrapper) {
    wrapper.classList.remove('show');
    setTimeout(() => wrapper.remove(), 150);
  }
  /**
   * @param {Object} options
   * @param {string} options.type Тип сообщения: 'success', 'warning', 'info', 'error'
   * @param {string} options.text Текст сообщения
   * @param {number} [options.autoCloseTime] Время авто-закрытия (в мс).
   *    Если передано 0 или не передано, сообщение не закрывается автоматически.
   *    По умолчанию для ошибок = 0, для остальных — 4000 мс.
   */
  showMessage({ type = 'info', text = '', autoCloseTime }) {
    this._init(document.querySelector('#message_manager'));
    // Определяем цвета и иконки для каждого типа
    const typeToAlert = {
      success: {
        cls: 'alert-success',
        icon: 'fa-check-circle'
      },
      warning: {
        cls: 'alert-warning',
        icon: 'fa-exclamation-triangle'
      },
      info: {
        cls: 'alert-info',
        icon: 'fa-info-circle'
      },
      error: {
        cls: 'alert-danger',
        icon: 'fa-times-circle'
      },
      primary: {
        cls: 'alert-primary',
        icon: 'fa-star'
      }
    };

    // Определяем дефолтное время автозакрытия
    // Для error – всегда 0 (либо явное значение, если передано)
    // Для остальных – 4000 мс, если не указано
    if (typeof autoCloseTime === 'undefined') {
      autoCloseTime = type === 'error' ? 0 : 4000;
    }

    // Формируем элемент сообщения
    const wrapper = document.createElement('div');
    wrapper.classList.add('alert', 'msg-alert', 'alert-dismissible', 'fade', 'show');
    wrapper.classList.add(typeToAlert[type]?.cls || 'alert-info');
    wrapper.closer = () => this.closer(wrapper);

    // Добавляем класс, если сообщение короткое
    if (text.length < 50) {
      wrapper.classList.add('short-message');
    }

    wrapper.innerHTML = `
      <i class="fa ${typeToAlert[type]?.icon || 'fa-info-circle'} msg-icon"></i>
      <div class="msg-text">${text}</div>
      <button type="button" class="btn-close" onclick="this.close()" data-bs-dismiss="alert" aria-label="Close"></button>
    `;

    // Добавляем элемент в контейнер
    this._container.prepend(wrapper);
    // Запускаем таймер на автозакрытие, если время > 0
    if (autoCloseTime > 0) {
      setTimeout(() => {
        wrapper.closer();
      }, autoCloseTime);
    }
  }
}
